export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Live-NBA-Spiele streamen | NBA.com',
	seo_meta_desc_leaguepass: 'Schau dir mit NBA League Pass Spiele live oder On-Demand an. Greif hier auf dein Konto zu.',
	seo_meta_keywords_leaguepass: 'NBA Videos, NBA Highlights, Basketball Videos, top-plays, dunks, berichte',
	seo_meta_title_featured: 'NBA-Spiele streamen & Highlights ansehen | NBA.com',
	seo_meta_desc_featured: 'Schau dir kostenlose NBA-Video-Highlights, News und Analysen an. Und entdecke die Abos für NBA TV und League Pass, um Live-Spiele auf deinen Lieblingsgeräten anzusehen.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Live-Spiele streamen und Berichterstattung rund um die Uhr | NBA.com',
	seo_meta_desc_nbatv: 'Streame NBA TV-Spiele live oder schau dir legendäre NBA-Klassiker an. Erhalte außerdem Zugang zu Studiosendungen und Analysen aus der ganzen Liga.',
	seo_meta_keywords_nbatv: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, Sprungball',
	seo_meta_title_classicgames: 'NBA-Klassiker und mehr mit NBA TV streamen | NBA.com',
	seo_meta_desc_classicgames: 'Streame legendäre NBA-Spiele mit NBA TV. Außerdem kannst du NBA TV-Spiele live streamen und auf Studiosendungen und Analysen aus der gesamten Liga zugreifen.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Hier Inhalte streamen | NBA.com',
	seo_meta_title_videolist: 'Hier {0} streamen | NBA.com',
	seo_meta_desc_videolist: 'Schau dir hier {0}-Videos an. Und entdecke die Abos für NBA TV und League Pass, um Live-Spiele auf deinen Lieblingsgeräten anzusehen.',
	seo_meta_title_videolist_show: '{0} mit NBA TV streamen | NBA.com',
	seo_meta_desc_videolist_show: 'Schau dir hier {0} an. Und streame NBA TV-Spiele live und greife auf NBA-Klassiker und Analysen zu.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Hier {0} streamen | NBA.com',
	seo_meta_desc_videolist_feed: 'Schau dir hier {0}-Videos an. Und entdecke die Abos für NBA TV und League Pass, um Live-Spiele auf deinen Lieblingsgeräten anzusehen.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Studiosendungen und mehr mit NBA TV streamen | NBA.com',
	seo_meta_desc_shows: 'Entdecke und streame die neuesten NBA-TV-Shows und -Episoden On-Demand. Außerdem kannst du NBA TV-Spiele live streamen und auf NBA-Klassiker und Analysen zugreifen.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Startseite | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Kanäle | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Kanal | NBA.com',
	seo_meta_pre_title_categories: 'Kategorien | NBA.com',
	seo_meta_title_categories: 'Kategorien | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Kategorie | NBA.com',
	seo_meta_title_category: 'Kategorie | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Video hier streamen | NBA.com',
	seo_meta_pre_title_event: 'Event hier streamen | NBA.com',
	seo_meta_title_events: 'Events | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: '{0} hier streamen | NBA.com',
	seo_meta_desc_event: 'Schau dir hier {0} an. Entdecke außerdem die Abos für NBA TV und League Pass, um Live-Spiele auf deinen Lieblingsgeräten anzusehen.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Suche | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Seite nicht gefunden | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Spiel hier streamen | NBA.com',
	seo_meta_title_game: '{0} hier streamen | NBA.com',
	seo_meta_desc_game: 'Schau dir hier {0} an. Und entdecke die Abos für NBA TV und League Pass, um Live-Spiele auf deinen Lieblingsgeräten anzusehen.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: '{0} hier streamen | NBA.com',
	seo_meta_desc_video: 'Schau dir hier {0} an. Entdecke außerdem die Abos für NBA TV und League Pass, um Live-Spiele auf deinen Lieblingsgeräten anzusehen.',
	seo_meta_keywords_video: 'NBA Videos, NBA Highlights, Basketball Videos, top-plays, dunks, berichte',
	seo_meta_title_episode: '{0} mit NBA TV streamen | NBA.com',
	seo_meta_desc_episode: 'Schau dir hier {0} an. Außerdem kannst du NBA TV-Spiele live streamen und auf NBA-Klassiker und Analysen zugreifen.',
	seo_meta_keywords_episode: 'NBA Videos, NBA Highlights, Basketball Videos, top-plays, dunks, berichte',
	seo_meta_title_channel: 'NBA TV Live | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live ist der Rund-um-die-Uhr-Livestream von NBA TV – jede Woche NBA-Spiele live oder aus dem Archiv, Sendungen aus dem Studio und Spielanalysen.',
	seo_meta_keywords_channel: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, Sprungball',
	seo_meta_title_tvguide: 'NBA TV Live-Stream Terminplan | NBA.com',
	seo_meta_desc_tvguide: 'Schau nach, wann du NBA TV-Spiele und Studiosendungen mit NBA TV live auf deinem Lieblingsgerät streamen kannst. Dazu hast du Zugriff auf On-Demand-Studiosendungen und -Analysen.',
	seo_meta_keywords_tvguide: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, Sprungball',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Es ist ein Fehler aufgetreten, der Inhalt ist jetzt nicht verfügbar. Möglicherweise kannst du es erneut versuchen.',
	watch_in_app: 'IN DER NBA-APP SCHAUEN',
	ad_blocked_message: 'Werbeblocker erkannt: NBA.com-Inhalte werden durch Werbung unterstützt. Deaktiviere bitte deinen Werbeblocker, um weiterhin Spaß an unseren Inhalten zu haben.',

	// Item
	no_content: 'Kein Inhalt',
	see_more: 'Mehr anzeigen',
	now_playing: 'AKTUELLE WIEDERGABE',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Du hast die maximale Anzahl an Lieblingsvideos erreicht. Entferne einige Lieblingsvideos, bevor du weitere hinzufügst.',
	item_live: 'Live:',
	add_favourite_title: 'ZU DEN FAVORITEN HINZUFÜGEN',
	remove_favourite_title: 'AUS FAVORITEN ENTFERNEN',
	// Channel: Schedule
	p_channel_live: 'Live:',
	p_channel_schedule_title: 'NBA-TV-Programm',
	p_channel_schedule_watch: 'Ansehen',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Alle Termine anzeigen',
	p_channel_live24x7_up_next: 'Als Nächstes',
	p_channel_live24x7_on_demand: 'NBA TV: On-Demand',
	p_channel_live24x7_collection: 'Kollektion',
	p_channel_live24x7_demand_1_logo_text: 'Originalsendungen',
	p_channel_live24x7_demand_1_show_name: 'NBA-TV-Shows',
	p_channel_live24x7_demand_1_show_desc: 'NBA-TV-Originalsendungen, darunter Shaqtin\' a Fool, Beyond the Paint, Game Time und Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Klassische Spiele',
	p_channel_live24x7_demand_2_show_name: 'NBA | Spiele-Klassiker',
	p_channel_live24x7_demand_2_show_desc: 'Sieh NBA-Klassiker in voller Länge, einschließlich aller Finals seit 2000, historischer Ligamomente und legendärer Spieler.',

	// Channel: Clips
	p_channel_error_msg: 'Noch nicht verfügbar',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Spielplan',

	// NBA TV Shows:
	p_nba_tv_shows: 'Exklusive NBA-TV-Shows',
	p_nba_tv_no_access_title: '24/7 NBA: Bleib auf dem Laufenden mit Spielanalysen, Studioanalysen, Originalsendungen und vielem mehr!',
	p_nba_tv_no_access_desc: 'Sieh Live-Spiele sowie Shows und NBA-Klassiker On-Demand.',
	p_nba_tv_no_access_note: 'Es können Übertragungseinschränkungen gelten.',

	// tv show item
	tv_show_item_latest_episode: 'letzte Folge',
	tv_show_item_no_latest_episode: 'keine letzte Folge',
	see_all: 'Alles ansehen',
	// header
	header_menu_watch: 'Ansehen',
	header_menu_featured: 'IM BLICKPUNKT',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Spieler',
	videos: 'Videos',
	teams: 'Teams',
	most_searched: 'AM HÄUFIGSTEN GESUCHT',
	no_result: 'Keine Daten',
	search_filter_type_most_relevant: 'Relevanteste',
	search_filter_type_most_viewed: 'Am häufigsten gesehen',
	search_filter_type_most_recent: 'Neueste',
	search_filter_type_last_30_days: 'Letzte 30 Tage',
	search_filter_type_last_6_months: 'Letzte 6 Monate',
	search_result_label: 'Suchergebnisse für \'{keyword}\'',
	search_result_info: 'Alle Ergebnisse für {keyword} anzeigen',
	search_placeholder: 'Videobibliothek durchsuchen',
	load_more: 'Weitere laden…',

	// button
	button_subscribe: 'Abonnieren',
	button_sign_in: 'Anmelden',
	button_tv_provider: 'Wähle einen TV-Anbieter',

	// league page
	p_league_pass_no_access_title: 'Sieh Spiele live oder als Wiederholung auf jedem Gerät, einschließlich Computer, Smartphone und Fernseher!',
	p_league_pass_no_access_desc: 'Sei bei der Action dabei: Sieh die gesamte Liga oder dein Lieblingsteam, wähle ein einzelnes Spiel aus oder weitere Optionen.',
	p_league_pass_no_access_note: 'Es gelten die Geschäftsbedingungen',

	// Video
	category_title: 'Video',
	p_video_playlist_title: 'Playlist:',
	p_video_episode_text: 'Folge',
	p_no_access_league_pass_title: 'Schalte den NBA League Pass frei, um Folgendes zu sehen:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Sei bei der Action dabei: Sieh die gesamte Liga oder dein Lieblingsteam, wähle ein einzelnes Spiel aus oder weitere Optionen.',
	p_no_access_league_pass_terms: 'Es gelten die Geschäftsbedingungen',
	p_no_access_league_pass_geo_desc: 'Aufgrund deines aktuellen Standorts kannst du dieses Spiel nicht über NBA League Pass und NBA TV sehen. Diese Spiele werden drei Tage nach der Übertragung für NBA League Pass-Abonnenten verfügbar sein. Bitte sieh in deinem lokalen Fernseh- und Radioprogramm nach, um zu erfahren, wo Übertragungen angeboten werden.',
	p_no_access_league_pass_not_found_desc: 'Das angeforderte Video wurde leider nicht gefunden.',
	p_no_access_event_geo_desc: 'Diese Sendung ist für Fans in den USA oder Kanada nicht verfügbar. Um sie zu sehen, schalte bitte in den USA ESPN und in Kanada TSN oder Sportsnet ein.',
	p_no_access_event_not_found_desc: 'Das angeforderte Event wurde leider nicht gefunden.',
	p_no_access_nba_tv_title: 'Schalte NBA TV frei, um Folgendes anzusehen:',
	p_no_access_nba_tv_desc: 'Sieh Live-Spiele sowie Shows und NBA-Klassiker On-Demand.',
	p_no_access_nba_tv_terms: 'Es gelten die Geschäftsbedingungen',
	p_no_access_nba_tv_geo_desc: 'Aufgrund deines aktuellen Standorts kannst du dieses Spiel nicht über NBA League Pass und NBA TV sehen. Diese Spiele werden drei Tage nach der Übertragung für NBA League Pass-Abonnenten verfügbar sein. Bitte sieh in deinem lokalen Fernseh- und Radioprogramm nach, um zu erfahren, wo Übertragungen angeboten werden.',
	p_no_access_nba_tv_not_found_desc: 'Der angeforderte Kanal wurde leider nicht gefunden.',
	p_no_access_up_next: 'Als Nächstes:',
	p_video_completed_title: 'Playlist abgeschlossen',
	p_video_completed_desc: 'Gehe zurück, um nach Inhalten zu suchen oder die nächste Playlist abzuspielen.',
	p_video_share_to: 'Teilen auf:',
	p_video_more_to_watch: 'Es gibt noch mehr zu sehen:',

	// Event
	p_event_section_title: 'EVENT',
	p_event_playlist_title: 'Playlist:',
	p_event_button_watch: 'Ansehen',
	p_event_button_listen: 'Anhören',
	p_event_button_ticket: 'Ticket',

	// notfound page
	notfound: 'Die angeforderte Seite wurde leider nicht gefunden.',
	notfound_desc: 'Überprüfe die URL auf Fehler.<br/>Du kannst auch versuchen, deinen Inhalt über die Seitennavigation oder das Suchtool zu finden.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Dein NBA League Pass Konto hat die maximale Anzahl Streams erreicht. Klicke auf „Fortsetzen“, um auf diesem Gerät weiterzuschauen.',
	modal_pcm_custom: 'Fortsetzen',
	modal_pcm_close: 'Abbrechen',
	modal_pcm_ok: 'OK',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Dieses Video kann nicht auf deinem Gerät wiedergegeben werden. Klicke<a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'> HIER</a> für weitere Hilfe.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	modal_video_unsupported_ok: 'OK',

	// FreeSample
	freesample_notice_time: 'Verbleibende Zeit',
	freesample_notice_title: 'Genieße deine {0} Minuten Zugang',
	freesample_notice_desc: 'Abonniere ein komplettes League Pass-Paket, um nach Ablauf der {0} Minuten weiter auf Inhalte zuzugreifen.',
	freesample_notice_subscribe_button: 'Abonnieren',
	freesample_notice_cancel_button: 'JEDERZEIT KÜNDBAR',
	freesample_popup_title: 'DEIN ZUGANG IST ABGELAUFEN',
	freesample_popup_subtitle: 'Abonniere League Pass, um noch mehr tolle NBA-Inhalte anzusehen.',
	freesample_popup_link: 'MEHR ERFAHREN!',
	freesample_popup_get_minutes_button: '{0}  MINUTEN HOLEN',

	// Video list
	reg_required_desc: 'Du musst dich anmelden, um diesen Inhalt anzusehen',
	favorite_teams_title: 'Lieblingsteams',
	bookmarked_title: 'Gespeichert',
	watch_history_title: 'Weiter schauen',
	game_schedule_title: 'Spielplan',
	recommended_title: 'Empfohlen',
	season_text: 'Saison',

	// profile page
	section_information_title: 'Meine Daten',
	section_information_desc: 'Aktualisiere bitte deine persönlichen Informationen',
	section_information_email: 'E-Mail',
	section_information_email_update: 'Aktualisiere bitte deine E-Mail-Adresse',
	section_information_password: 'Passwort',
	section_information_password_update: 'Passwort ändern',
	section_information_social: 'Verknüpfungen mit sozialen Netzwerken',
	section_information_nosocial_message: 'Du hast keine verknüpften Konten.',
	section_information_firstname: 'Vorname',
	section_information_lastname: 'Nachname',
	section_information_birth: 'Geburtsdatum',
	section_information_country: 'Land / Region',
	section_information_postalcode: 'Postleitzahl',
	section_information_edit: 'Bearbeiten',
	section_tv_provider_title: 'Mein TV-Anbieter',
	section_tv_provider_desc: 'Erhalte Zugriff auf Live-Spiele und Streams von deinem TV-Anbieter.',
	section_tv_provider_faq: 'FAQs zu TV-Anbietern',
	section_tv_provider_sign_out: 'Abmelden',
	section_tv_provider_sign_in: 'Bei TV-Anbieter anmelden',
	section_fantasy_title: 'Fantasy',
	section_fantasy_desc: 'Fantasy-Kontoinformationen anzeigen',
	section_fantasy_displayname: 'Anzeigename',
	section_marketing_title: 'Meine E-Mail-Einstellungen',
	section_marketing_desc: 'Einstellungen zu Marketingkommunikation und Datenschutz anzeigen',
	section_marketing_newsletters: 'Newsletter',
	section_marketing_newsletters_desc_1: 'NBA-News täglich frisch in deiner Inbox',
	section_marketing_newsletters_desc_2: 'NBA G League News und Features aus der offiziellen Farmliga der NBA',
	section_marketing_newsletters_desc_3: 'Jr. NBA-News und Inhalte von der Jugendbasketball-Initiative der NBA',
	section_marketing_newsletters_desc_4: 'Neueste Funktionen in der NBA-App sowie League Pass-Updates und -Angebote',
	section_marketing_newsletters_desc_5: 'Besondere Ticketangebote, Partnerangebote, Events und Rabatte auf NBA-Artikel',
	section_marketing_newsletters_desc_6: 'Handverlesene NBA-News und -Inhalte gehen wöchentlich raus an deine Inbox.',
	section_marketing_newsletters_desc_7: 'WNBA-News und Angebote von der WNBA und ihren Partnern',
	section_marketing_message: 'NBA-Benachrichtigungen und -Werbung',
	section_marketing_personal_title: 'Meine persönlichen Informationen',
	section_marketing_personal_desc: 'Bitte verwenden Sie meine persönlichen Daten für die NBA, um mir Nachrichten und Werbung zu Produkten und Initiativen der NBA und NBA-Partner zu senden.',
	section_marketing_update_button: 'Marketingeinstellungen aktualisieren',
	section_marketing_update_success: 'Deine Einstellungen wurden erfolgreich aktualisiert.',
	section_ccpa_title: 'Meine persönlichen Daten nicht verkaufen',

	// profile edit modal
	email_modal_title: 'E-Mail-Adresse aktualisieren',
	email_modal_new_email_label: 'Neue E-Mail-Adresse',
	email_modal_update: 'Aktualisieren',
	email_modal_cancel: 'Abbrechen',
	password_modal_title: 'Passwort ändern',
	password_modal_current_label: 'Aktuelles Kennwort:',
	password_modal_new_label: 'Neues Kennwort:',
	password_modal_confirm_label: 'Kennwort bestätigen',
	password_modal_update: 'Aktualisieren',
	password_modal_cancel: 'Abbrechen',
	personal_modal_title: 'Persönliche Informationen aktualisieren',
	personal_modal_email: 'E-Mail',
	personal_modal_password: 'Passwort',
	personal_modal_birth: 'Geburtsdatum',
	personal_modal_social: 'Verknüpfungen mit sozialen Netzwerken',
	personal_modal_firstname: 'Vorname',
	personal_modal_lastname: 'Nachname',
	personal_modal_country: 'Land / Region',
	personal_modal_postalcode: 'Postleitzahl',
	personal_modal_zipcode: 'postleitzahl',
	personal_modal_postalcode_invalid_message: 'Muss eine gültige Postleitzahl sein',
	personal_modal_zipcode_invalid_message: 'Muss eine gültige Postleitzahl sein',
	personal_modal_update: 'Aktualisieren',
	personal_modal_cancel: 'Abbrechen',

	// payflow
	payflow_profile_name: 'Name',
	payflow_profile_email: 'E-Mail',

	// account page
	header_menu_account_my_account: 'Mein Konto',
	header_menu_account_manage_account: 'Konto verwalten',
	header_menu_account_favorite_teams: 'Lieblingsteams',
	header_menu_account_favorite_players: 'Lieblingsspieler',
	header_menu_account_viewing_history: 'Bisher angesehen',
};
